class FatalErrorHandler {
  static onFatalError(reason) {
    console.log(reason);
    // TODO handle fatal error so the user can recover from it
    // LoginHelper.setLoginCookie(null);
  }
}

export default FatalErrorHandler;
